/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import r from"@babel/runtime/helpers/esm/extends";import{forwardRef as o,createElement as i}from"react";import t from"react-dom";import{Primitive as e}from"../../react-primitive/dist/index.js";const l=o(((o,l)=>{var a;const{container:m=(null===globalThis||void 0===globalThis||null===(a=globalThis.document)||void 0===a?void 0:a.body),...n}=o;return m?t.createPortal(i(e.div,r({},n,{ref:l})),m):null}));export{l as Portal};
//# sourceMappingURL=index.js.map
